import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_L1_MENU_PERMISSIONS_CHR, GET_L1_MENU_PERMISSIONS_ROLE_CHR, CURD_L1_SERVICE_PERMISSIONS_CHR, GET_L1_SERVICE_PERMISSIONS_ROLE_CHR } from "../../../../utils/routes";

// ---------------------------------------------------------------------

export const createL1MenuPermissionChr = createAsyncThunk(
  "l1AccessPermission/createL1MenuPermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_L1_MENU_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getL1MenuPermissionChr = createAsyncThunk("l1AccessPermission/getL1MenuPermissionChr", async (obj, {rejectWithValue}) => {
  try {
    const response = await axios.get(CURD_L1_MENU_PERMISSIONS_CHR, { withCredentials: true });
    return response;
  } catch (err) {
    return rejectWithValue(err.response)
  }
});

export const getL1MenuPermissionChrRole = createAsyncThunk("l1AccessPermission/getL1MenuPermissionChrRole", async (id) => {
  return axios.get(`${GET_L1_MENU_PERMISSIONS_ROLE_CHR}/${id}`, { withCredentials: true });
});

export const updateL1MenuPermissionChr = createAsyncThunk(
  "l1AccessPermission/updateL1MenuPermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_L1_MENU_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL1MenuPermissionChr = createAsyncThunk(
  "l1AccessPermission/deleteL1MenuPermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_L1_MENU_PERMISSIONS_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const createL1ServicePermissionChr = createAsyncThunk(
  "l1AccessPermission/createL1ServicePermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_L1_SERVICE_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getL1ServicePermissionChr = createAsyncThunk("l1AccessPermission/getL1ServicePermissionChr", async () => {
  return axios.get(CURD_L1_SERVICE_PERMISSIONS_CHR, { withCredentials: true });
});

export const getL1ServicePermissionChrRole = createAsyncThunk("l1AccessPermission/getL1ServicePermissionChrRole", async (id) => {
  return axios.get(`${GET_L1_SERVICE_PERMISSIONS_ROLE_CHR}/${id}`, { withCredentials: true });
});

export const updateL1ServicePermissionChr = createAsyncThunk(
  "l1AccessPermission/updateL1ServicePermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_L1_SERVICE_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL1ServicePermissionChr = createAsyncThunk(
  "l1AccessPermission/deleteL1ServicePermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_L1_SERVICE_PERMISSIONS_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const l1AccessPermissionSlice = createSlice({
  name: "l1AccessPermission",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    l1MenuPermissionData: [],
    l1MenuSelectedData: {},
    l1ServicePermissionData: [],
    l1ServiceSelectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    l1MenuRowSelect: (state, action) => {
      state.l1MenuSelectedData = action?.payload.length > 0 && action?.payload[0];
    },
    l1ServiceRowSelect: (state, action) => {
      state.l1ServiceSelectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createL1MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createL1MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL1MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getL1MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getL1MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l1MenuPermissionData = action?.payload?.data;
    },
    [getL1MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [getL1MenuPermissionChrRole.pending]: (state, action) => {
      state.loading = true;
    },
    [getL1MenuPermissionChrRole.fulfilled]: (state, action) => {
      state.loading = false;
      state.l1MenuPermissionChrData = action?.payload?.data;
    },
    [getL1MenuPermissionChrRole.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL1MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL1MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL1MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL1MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL1MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL1MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [createL1ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createL1ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL1ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getL1ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getL1ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l1ServicePermissionData = action?.payload?.data;
    },
    [getL1ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [getL1ServicePermissionChrRole .pending]: (state, action) => {
      state.loading = true;
    },
    [getL1ServicePermissionChrRole .fulfilled]: (state, action) => {
      state.loading = false;
      state.l1ServicePermissionData = action?.payload?.data;
    },
    [getL1ServicePermissionChrRole .rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL1ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL1ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL1ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL1ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL1ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL1ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, l1MenuRowSelect, l1ServiceRowSelect } = l1AccessPermissionSlice.actions;
export default l1AccessPermissionSlice.reducer;
